const name = 'TurnIn';
const properties = {
    hideOnStart: true,
    mobile: true,
    viewportThreshold: 0.15,
    groups: ['entrance', 'animation'],
    schema: {
        duration: {
            type: 'number',
            min: 0,
            default: 0,
        },
        delay: {
            type: 'number',
            min: 0,
            default: 0,
        },
        direction: {
            type: 'string',
            enum: ['right', 'left'],
            default: 'right',
        },
    },
};
const paramsMap = {
    left: { dx: -1, angle: 45 },
    right: { dx: 1, angle: 45 },
};
function animate(kit, elements, duration, delay, { direction = properties.schema.direction.default, ...params } = {}) {
    const origin = paramsMap[direction];
    const transformRotate = (origin.dx > 0 ? '+=' : '-=') + origin.angle;
    const browserRect = {
        width: kit.frame.innerWidth,
        height: kit.frame.innerHeight,
    };
    const sequence = kit.sequence(params);
    sequence.add(kit.animate('BaseFade', elements, duration, delay, {
        from: { opacity: 0 },
        to: { opacity: 1 },
        ease: 'Linear.easeIn',
    }));
    elements.forEach((element) => {
        /// This will end up as a new animation:
        // const transformOrigin = origin.dx > 0 ? '100% 100%' : '0 100%'
        // sequence.add([
        //     setSmoothTransformOrigin(element, transformOrigin, kit.animate),
        //     kit.animate('BaseRotate', element, duration, delay, {
        //         from: {rotation: transformRotate},
        //         ease: 'Quad.easeOut',
        //         immediateRender: false
        //     })
        // ], 0)
        const compRect = kit.engine.getBoundingRect(element);
        const transformX = origin.dx > 0 ? browserRect.width - compRect.left : -compRect.right;
        const transformY = Math.min(-1.5 * compRect.height, Math.max(-300, -5.5 * compRect.height));
        sequence.add([
            kit.animate('BasePosition', element, duration, delay, {
                from: { x: transformX },
                ease: 'Circ.easeOut',
                immediateRender: false,
            }),
            kit.animate('BasePosition', element, duration, delay, {
                from: { y: transformY },
                ease: 'Linear.easeOut',
                immediateRender: false,
            }),
            kit.animate('BaseRotate', element, duration, delay, {
                from: { rotation: transformRotate },
                ease: 'Linear.easeOut',
                immediateRender: false,
            }),
        ], 0);
    });
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=turnIn.js.map